import {RiskRowEntityType} from "../RiskRowEntityType";
import {Optional} from "../../../../js/util/Optional";

export class RiskDashboardCollapseState {

    private constructor(private readonly states = new Map<RiskRowEntityType, Map<number, boolean>>()) {

    }

    public get(type: RiskRowEntityType, id: number): boolean {
        let typeStates = this.states.get(type);
        if (typeStates == null) {
            typeStates = new Map();
        }
        let state = typeStates.get(id);
        if (state == null) {
            state = this.defaultCollapseState(type);
        }
        typeStates.set(id, state);
        this.states.set(type, typeStates);
        return state;
    }

    private defaultCollapseState(type: RiskRowEntityType): boolean {
        switch (type) {
            case RiskRowEntityType.ORG:
            case RiskRowEntityType.BROKER:
            case RiskRowEntityType.BRANCH:
                return false;
            case RiskRowEntityType.ADVISER:
            case RiskRowEntityType.CLIENT:
                return true;
        }
    }

    public set(type: RiskRowEntityType, id: number, collapsed: boolean): RiskDashboardCollapseState {
        const typeStates = Optional.of(type)
                                   .map((t) => this.states.get(t))
                                   .orElseGet(() => new Map());
        typeStates.set(id, collapsed);

        const copy = new Map(this.states.entries());
        copy.set(type, typeStates);

        return new RiskDashboardCollapseState(copy);
    }

    public collapseAll(): RiskDashboardCollapseState {
        const result = new Map<RiskRowEntityType, Map<number, boolean>>();

        Array.from(this.states.keys())
            .forEach((key) => {
                const type = this.states.get(key)!;
                const typeCopy = new Map<number, boolean>();

                Array.from(type.keys())
                     .forEach((id) => typeCopy.set(id, true));

                result.set(key, typeCopy);
            });

        return new RiskDashboardCollapseState(result);
    }

    public static init(): RiskDashboardCollapseState {
        return new RiskDashboardCollapseState();
    }
}
